module.exports = __webpack_public_path__ + "static/media/Logo.b9e45c47.png";